import React, {useState, useCallback, useEffect} from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import VM from 'scratch-vm';
import styles from './codework-modal.css';
import codeworkIcon from './oct-logo.svg';
import closeIcon from './icons/icon--close.svg';
import directoryIcon from './icons8-file-folder-20.png';
import fileIcon from './icons8-file-20.png';
import { connect } from 'react-redux';
import { setCodeworkAccessToken, setFileServiceRoot,
         listDir, getFile
        } from './fileslib';
import {
    LoadingStates,
    getIsLoadingFromCodework,
    getIsShowingWithoutId,
    onLoadedProject,
    requestProjectUploadFromCodework
} from '../../reducers/project-state';
import { setProjectTitle } from '../../reducers/project-title';
import { setCodeworkFilepath } from '../../reducers/codework-filepath';
import {
    openLoadingProject,
    closeLoadingProject
} from '../../reducers/modals';

const messages = defineMessages({
    title: {
        id: 'gui.loadCodeworkFileModal.title',
        defaultMessage: 'Load file from Codework',
        description: 'title for the load-codework-file modal'
    }
});

function getProjectTitleFromFilename (fileInputFilename) {
  if (!fileInputFilename) return '';
  // only parse title with valid scratch project extensions
  // (.sb, .sb2, and .sb3)
  const matches = fileInputFilename.match(/^(.*)\.sb[23]?$/);
  if (!matches) return '';
  return matches[1].substring(0, 100); // truncate project title to max 100 chars
}

const paramsString = window.location.search;
const params = new URLSearchParams(paramsString);
setCodeworkAccessToken(params.get('u'));
setFileServiceRoot(params.get('fs'));

class CodeworkFileLoadModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = { 
      pathElts: ['~'], 
      dirsAndFiles: [],
      selectedFilename: null
    };
  }

  handleClose = () => {
    console.log('handleClose', this.state);
    // this.setState({ pathElts: ['~'], dirsAndFiles: [], selectedFilename: null });
    this.props.onClose();
  };

  updateDirsAndFilesState = (listing) => {
    this.setState({ pathElts: this.state.pathElts, dirsAndFiles: listing, selectedFilename: null });
  }

  listDirectory = () => {
    const path = this.state.pathElts.join('/');
    listDir(path, this.updateDirsAndFilesState);
  }

  componentDidMount = () => {
    this.listDirectory();
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevState.pathElts.length !== this.state.pathElts.length) {
      this.listDirectory();
    }
    // console.log('componentDidUpdate', this.props.loadingState, this.props.isLoadingUpload, prevProps.isLoadingUpload);
    // console.log('componentDidUpdate', this.state);
    if (this.props.isLoadingUpload && !prevProps.isLoadingUpload) {
        this.startFileLoad(); // cue step 2 below
    }
  }

  selectDir = (dir) => {
    console.log(this.state);
    this.setState({ pathElts: this.state.pathElts.concat(dir), dirsAndFiles: this.state.dirsAndFiles, selectedFilename: null });
  }

  // stringToArrayBuffer = (str) => {
  //   var buf = new ArrayBuffer(str.length); // 1 byte for each char
  //   var bufView = new Uint8Array(buf);
  //   for (var i=0, strLen=str.length; i < strLen; i++) {
  //     bufView[i] = str.charCodeAt(i);
  //   }
  //   return buf;
  // }

  // step 3
  getFileCallback = (filepath, fileObj) => {
    console.log('getFileCallback', this.props.loadingState);
    // this.props.onLoadingStarted();
    const content = fileObj.content;
    console.log(content.length, typeof content);
    // console.log(content);
    let loadingSuccess = false;
    // loadProject expects an ArrayBuffer, so convert the string to one
    // using the stringToArrayBuffer function above
    this.props.vm.loadProject(content) //this.stringToArrayBuffer(content))
    .then(() => {
      loadingSuccess = true;
      const filename = filepath.split('/').at(-1);
      const uploadedProjectTitle = getProjectTitleFromFilename(filename);
      this.props.onSetProjectTitle(uploadedProjectTitle);
      this.props.onSetCodeworkFilepath(filepath);
    })
    .catch(error => {
      console.log(error);
      alert('The project file that was selected failed to load'); // eslint-disable-line no-alert
    })
    .then(() => {
      this.props.onLoadingFinished(this.props.loadingState, loadingSuccess);
    });
  }

  selectFile = (itemName) => {
    this.setState({ pathElts: this.state.pathElts, dirsAndFiles: this.state.dirsAndFiles, selectedFilename: itemName });
  }

  // step 1.
  // after requesting project upload, wait for isLoadingUpload to change (componentDidMount)
  initFileLoad = () => {
      console.log('initFileLoad', this.props.loadingState);
      this.props.requestProjectUpload(this.props.loadingState);
      this.handleClose();
  }

  // step 2
  startFileLoad = () => {
    console.log('startFileLoad', this.props.loadingState, this.state.selectedFilename);
    if (this.state.selectedFilename) {
      // this.props.onLoadingStarted();
      const filepath = this.state.pathElts.concat(this.state.selectedFilename).join('/');
      getFile(filepath, this.getFileCallback);
    } else {
      this.props.cancelFileUpload(this.props.loadingState);
      this.handleClose();
    }
  }

  selectParent = () => {
    console.log(this.state);
    this.setState({ pathElts: this.state.pathElts.slice(0, -1), dirsAndFiles: this.state.dirsAndFiles, selectedFilename: null });
  }

  dirListingItem = (item) => {
    return (
      <div key={item.name} className={styles.codeworkFileListingItem}>
        <img src={directoryIcon} />
        <div className={styles.codeworkFileListingItemName}>
          <a className={styles.codeworkFileListingDirItem} onClick={() => this.selectDir(item.name)} href="#">{item.name}</a>
        </div>
      </div>
    );
  }

  fileListingItem = (item) => {
    const isSelected = this.state.selectedFilename && this.state.selectedFilename === item.name;
    return (
      <div key={item.name} className={isSelected ? styles.codeworkFileListingItemSelected : styles.codeworkFileListingItem}>
        <img src={fileIcon} />
        <div className={styles.codeworkFileListingItemName}>
          <a className={styles.codeworkFileListingFileItem} onClick={() => this.selectFile(item.name)} href="#">{item.name}</a>
        </div>
      </div>
    );
  }

  breadcrumb = (pathElt) => {
    return (
      <span key={pathElt}>
        <a href="#" className={styles.codeworkFileListingDirItem} onClick={() => this.selectParent()}>{pathElt}</a>
        &nbsp;/&nbsp;
      </span>
    )
  }

  breadcrumbsNav = () => {
    const pathElts2 = this.state.pathElts.map(elt => elt === '~' ? 'My files' : elt)
    return (
      <p className={styles.breadcrumbsNav}>
        { pathElts2.slice(0, -1).map(elt => this.breadcrumb(elt)) }
        <span>{pathElts2.at(-1)}</span>
      </p>
    )
  }

  render() {
    if (!this.props.isOpen) return null;

    const dirs = this.state.dirsAndFiles.filter(item => item.type === 'dir');
    const files = this.state.dirsAndFiles.filter(item => item.type === 'file');

    return (
      <ReactModal
        isOpen={this.props.isOpen}
        onRequestClose={this.handleClose}
        className={styles.codeworkModalContainer}
        overlayClassName={styles.codeworkModalOverlay}
    >
        <div className={styles.modalHeader}>
          <div className={styles.headerTitle}>
            <img
              className={styles.codeworkIcon}
              src={codeworkIcon}
            />
            <FormattedMessage
              {...messages.title}
            />
          </div>
          <button
            className={styles.closeButton}
            onClick={this.handleClose}
          >
          <img
            className={styles.closeIcon}
            src={closeIcon}
          />
          </button>
        </div>
        <div className={styles.modalContent} >
          <div>
            {this.breadcrumbsNav()}
            {dirs.map(dorf => this.dirListingItem(dorf))}
            {files.map(dorf => this.fileListingItem(dorf))}
          </div>
        </div>
        <div className={styles.modalActions} >
          <button onClick={this.handleClose} className={styles.cancelButton}>Cancel</button>
          <button onClick={this.initFileLoad} className={styles.loadButton}>Load</button>
        </div>
      </ReactModal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const loadingState = state.scratchGui.projectState.loadingState;
  const retObj = {
    isLoadingUpload: getIsLoadingFromCodework(loadingState),
    isShowingWithoutId: getIsShowingWithoutId(loadingState),
    loadingState: loadingState,
    projectChanged: state.scratchGui.projectChanged,
    vm: state.scratchGui.vm
  };
  // console.log('mapStateToProps', retObj);
  return retObj;
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  cancelFileUpload: loadingState => dispatch(onLoadedProject(loadingState, false, false)),
  // transition project state from loading to regular, and close
  // loading screen and file menu
  onLoadingFinished: (loadingState, success) => {
    console.log('onLoadingFinished', loadingState);
    dispatch(onLoadedProject(loadingState, /* ownProps.canSave */ false, success));
    dispatch(closeLoadingProject());
  },
  // show project loading screen
  onLoadingStarted: () => dispatch(openLoadingProject()),
  onSetProjectTitle: title => dispatch(setProjectTitle(title)),
  onSetCodeworkFilepath: codeworkFilepath => dispatch(setCodeworkFilepath(codeworkFilepath)),
  // step 4: transition the project state so we're ready to handle the new
  // project data. When this is done, the project state transition will be
  // noticed by componentDidUpdate()
  requestProjectUpload: loadingState => dispatch(requestProjectUploadFromCodework(loadingState))
});

export default connect(mapStateToProps, mapDispatchToProps)(CodeworkFileLoadModal);
